import React from "react";
import Footer from "../../components/Footer";
import AccountType from "../../components/AccountType";

const SelectAccountPage = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&display=swap');

        html, body {
          margin: 0;
          background: #ffffff !important;
        }

        .dd-root {
          font-family: 'DM Sans', sans-serif;
          background: #ffffff;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 20px;
        }

        .dd-form-container {
          width: 100%;
          max-width: 400px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          gap: 24px;
          margin: auto;
          text-align: center;
        }

        .dd-title {
          font-size: 24px;
          font-weight: 700;
          color: #0F172A;
          margin: 0 0 8px 0;
        }

        .dd-text {
          font-size: 13px;
          color: #64748B;
          line-height: 1.5;
        }

        .dd-logo {
          height: 40px;
        }
      `}</style>

      <div className="dd-root">
        <div className="dd-form-container">
          <div>
            <img src="assets/main-logo.svg" alt="Logo" className="dd-logo" />
          </div>

          <div>
            <h1 className="dd-title">
              Welcome to 6EL∆
            </h1>
            <p className="dd-text" style={{ marginTop: 8 }}>
              Please select your account type to continue
            </p>
          </div>

          {/* AccountType component still rendered as before */}
          <AccountType />
        </div>

        <Footer />
      </div>
    </>
  );
};

export default SelectAccountPage;
